import { ApiMapType, Methods } from "types/api.d";

const LEUMIT_VALIDATION_TIMEOUT_MS = 5000;

const ApiMap: ApiMapType = {
  uploadImageToS3: {
    url: "",
    method: Methods.PUT,
    noAuthHeader: true,
  },
  requestPresignedUrls: {
    url: import.meta.env.VITE_LAMBDA_API_ENDPOINT || '',
    method: Methods.POST,
    noAuthHeader: true,
    noCredentials: true,
  },
  updateMetadata: {
    url: import.meta.env.VITE_LAMBDA_API_ENDPOINT || '',
    method: Methods.POST,
    noAuthHeader: true,
    noCredentials: true,
  },
  createZip: {
    url: import.meta.env.VITE_LAMBDA_API_ENDPOINT || '',
    method: Methods.POST,
    noAuthHeader: true,
    noCredentials: true,
  },
  sendCloudWatchLog: {
    url: import.meta.env.VITE_CLOUDWATCH_LOG_ENDPOINT || '',
    method: Methods.POST,
    noAuthHeader: true,
    noCredentials: true,
  },
  validateLeumitTokenLambda: {
    url: import.meta.env.VITE_LEUMIT_TOKEN_VALIDATION_URL || '',
    method: Methods.POST,
    noAuthHeader: true,
    noCredentials: true,
    silentErrors: true,
    timeout: LEUMIT_VALIDATION_TIMEOUT_MS,
  },
  validateLeumitTokenDirect: {
    url: `${import.meta.env.VITE_LEUMIT_TOKEN_VALIDATION_URL || ''}/:token`,
    method: Methods.GET,
    noAuthHeader: true,
    noCredentials: true,
    silentErrors: true,
    timeout: LEUMIT_VALIDATION_TIMEOUT_MS,
  },
};

export default ApiMap;
